// ─────────────────────────────────────────────────────────────────────────
// Champ utilisateur « tech_to_show_planning_technicien » : techniciens à
// afficher sur le Planning Opérateur + couleur de leurs interventions.
//
// Formats acceptés en LECTURE (tous compatibles) :
//   • ancien format, liste séparée par des virgules :
//       "ETHYLOTEST,VGP,TACHYGRAPHE"
//   • nouveau format, objet { nom du technicien : couleur } ("" = pas de couleur) :
//       {"ETHYLOTEST":"#E53935","VGP":"","TACHYGRAPHE":"#1E88E5"}
//   • tableau de noms ou d'objets : ["VGP","PEINTURE"] / [{"nom":"VGP","couleur":"#43A047"}]
//   • la même chose déjà décodée (objet / tableau au lieu d'une chaîne JSON).
// En ÉCRITURE, on produit toujours le nouveau format (objet JSON).
// ─────────────────────────────────────────────────────────────────────────

const txt = (v) => (v === undefined || v === null ? "" : String(v));

// Couleur valide : #RGB, #RRGGBB, #RRGGBBAA ou nom CSS simple (ex. "purple").
// Renvoie "" si la valeur est vide ou invalide.
export function normalizeColor(value) {
    const s = txt(value).trim();
    if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(s)) return s.toUpperCase();
    if (/^[a-z]{3,30}$/i.test(s)) return s.toLowerCase();
    return "";
}

// { names: [noms dans l'ordre], colors: { nom: couleur } }
export function parseTechToShow(value) {
    const res = { names: [], colors: {} };
    let v = value;
    if (typeof v === "string") {
        const s = v.trim();
        if (!s) return res;
        if (s.charAt(0) === "{" || s.charAt(0) === "[") {
            try { v = JSON.parse(s); } catch (e) { v = s; }
        } else {
            v = s;
        }
    }
    const add = (name, color) => {
        const n = txt(name).trim();
        if (!n || res.names.indexOf(n) !== -1) return;
        res.names.push(n);
        const c = normalizeColor(color);
        if (c) res.colors[n] = c;
    };
    const colorOf = (o) => (o && typeof o === "object" ? (o.couleur !== undefined ? o.couleur : o.color) : o);
    if (typeof v === "string") {
        v.split(",").forEach((n) => add(n, ""));
    } else if (Array.isArray(v)) {
        v.forEach((it) => {
            if (it && typeof it === "object") {
                const name = it.nom !== undefined ? it.nom : (it.name !== undefined ? it.name : it.technicien);
                add(name, colorOf(it));
            } else {
                add(it, "");
            }
        });
    } else if (v && typeof v === "object") {
        Object.keys(v).forEach((k) => add(k, colorOf(v[k])));
    }
    return res;
}

// Objet JSON { nom : couleur } pour les techniciens sélectionnés (dans l'ordre).
export function serializeTechToShow(names, colors) {
    const obj = {};
    (names || []).forEach((n) => {
        const name = txt(n).trim();
        if (!name) return;
        obj[name] = normalizeColor(colors && colors[name]);
    });
    return JSON.stringify(obj);
}

// Texte lisible sur un fond donné : blanc sur couleur foncée, presque noir
// sur couleur claire (jaune, vert clair…). Couleurs nommées → blanc.
export function readableTextColor(color) {
    const c = normalizeColor(color);
    const m = /^#([0-9A-F]{3}|[0-9A-F]{6})/.exec(c);
    if (!m) return "#FFFFFF";
    let hex = m[1];
    if (hex.length === 3) hex = hex.split("").map((x) => x + x).join("");
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.62 ? "#1B1F27" : "#FFFFFF";
}
